import { getCmsUsefulInfoDetailBySlug } from "../../../app/api/getCmsUsefulInfoDetailBySlug";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { ICmsUsefulInformation, ICmsUsefulInformationResponse, IGetCmsUsefulInformationActionParams } from "../../../Orchestrator/Types/Interface/ICmsUsefulInformaton";

class GetCmsUsefulInfoDetailAction extends BaseAction<
  ICmsUsefulInformation[],
  IGetCmsUsefulInformationActionParams
> {
  override async run(): Promise<ICmsUsefulInformation[] | null> {
    let usefulInfoDetail: ICmsUsefulInformation[] | null = null;
    try {
      const { slug } = this.params!;
      if (!slug) {
        return null;
      }
      const response: IApiResponse<ICmsUsefulInformationResponse> = await getCmsUsefulInfoDetailBySlug(slug);
      if (response.status === "ok" && response.answer) {
        const usefulInfo = response.answer.data;
        if (usefulInfo.length > 0) {
          usefulInfoDetail = usefulInfo;
          updateRecoilState("usefulInfoDetailAtom", usefulInfoDetail);
        } else {
          updateRecoilState("usefulInfoDetailAtom", null);
          console.warn("No useful information available.");
        }
      } else {
        console.warn("Failed to fetch useful information.");
      }
    } catch (error: any) {
      console.error("Error fetching useful information:", error);
    } finally {
      return usefulInfoDetail;
    }
  }
}

export const getCmsUsefulInfoDetailAction = new GetCmsUsefulInfoDetailAction();
